import type { ReactNode } from 'react';

function escapeRegex(text: string): string {
    return text.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
}

/**
 * Wraps occurrences of `query` in `text` with a highlighted `<mark>` element.
 * Returns a ReactNode array suitable for rendering inside JSX.
 */
export function highlightText(text: string, query: string): ReactNode {
    if (!query || !text) return text;
    const regex = new RegExp(`(${escapeRegex(query)})`, 'gi');
    const parts = text.split(regex);
    return parts.map((part, i) =>
        regex.test(part) ? (
            <mark key={i} className="rounded-sm bg-warning-200 text-foreground">
                {part}
            </mark>
        ) : (
            part
        ),
    );
}
